import { useEffect } from "react";
import { fetchSubscription } from "@/server/services/stripeService";
import { useSubscriptionState } from "@/zustand/SubscriptionState";

/**
 * Fetches a fresh subscription from the server once on mount.
 * Silently ignores errors — the cached Zustand state remains valid as fallback.
 * Mount this in ChatPage so it runs after every authenticated session start.
 */
export function useSubscriptionRefresh() {
  const setSubscription = useSubscriptionState((s) => s.setSubscription);

  useEffect(() => {
    fetchSubscription()
      .then(setSubscription)
      .catch(() => {});
  }, [setSubscription]);
}
